var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPill(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.79475,
    height: 51.7829,
    viewBox: "0 0 51.79475 51.7829",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-3{fill:#ea5a47;}.cls-4{fill:#92d3f5;}.cls-5{fill:#d22f27;}.cls-6{fill:#61b2e4;}.cls-2{stroke:#000;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "emoji"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M34.44948,34.4401l-11.81,11.81c-4.53,4.54-11.85,4.7-16.58,.4901,8.96,.08,8.4,.65,24.87-15.82l3.52,3.5199Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.92948,30.9201c-16.47,16.47-15.91,15.9-24.87,15.82-.18-.16-.35-.32-.52-.4901-2.35-2.35-3.53-5.45-3.53-8.55s1.18-6.2,3.53-8.55l11.81-11.81,13.58,13.5801Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M46.96947,4.8301c-2.47-2.47-5.75-3.83-9.2599-3.83s-6.8,1.36-9.26,3.83l-12.5201,12.51,18.52,18.52,12.51-12.52c2.47-2.46,3.83-5.75,3.83-9.26,0-3.5-1.36-6.79-3.82001-9.25Zm-.71,17.8l-11.81,11.81-3.52-3.52,1.31-1.31c15.72-15.72,8.77-25.05,6.21-27.59,2.85,.18,5.65,1.35,7.81,3.51,2.35,2.35,3.53,5.45,3.53,8.55,0,3.1-1.18,6.2-3.53,8.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M47.66947,4.1201c-2.65-2.66-6.19-4.1201-9.96-4.1201-3.78,0-7.32,1.46-9.97,4.1201l-13.22,13.22,1.41,1.42,17.1,17.1,1.42,1.41,13.22-13.22c2.66-2.66,4.12-6.2,4.12-9.97s-1.46-7.31-4.12-9.96Zm-13.22,30.32l-3.52-3.52-13.58-13.58L29.15948,5.5301c2.35-2.35,5.45-3.53,8.55-3.53,.25,0,.49,.01,.74,.02,2.85,.18,5.65,1.35,7.81,3.51,2.35,2.35,3.53,5.45,3.53,8.55s-1.18,6.2-3.53,8.55l-11.81,11.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M49.78947,14.0801c0,3.1-1.18,6.2-3.53,8.55l-11.81,11.81-3.52-3.52,1.31-1.31c15.72-15.72,8.77-25.05,6.21-27.59,2.85,.18,5.65,1.35,7.81,3.51,2.35,2.35,3.52999,5.45,3.52999,8.55Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.34737,
    y1: 17.3436,
    x2: 16.77737,
    y2: 16.7636
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 30.58672,
    y: 29.12073,
    width: 6.56404,
    height: 5.80814,
    transform: "translate(-12.72503 33.32866) rotate(-45)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.70717,2.0043c3.1001,0,6.2001,1.1759,8.5519,3.5276h0c4.7035,4.7035,4.7035,12.4002,0,17.1038l-23.6196,23.6195c-2.3518,2.3518-5.4518,3.5277-8.5519,3.5277s-6.2001-1.1759-8.5519-3.5277h0c-4.7035-4.7035-4.7035-12.4002,0-17.1038L29.15518,5.5319c2.3518-2.3518,5.4519-3.5276,8.552-3.5276M37.70717,.0043C33.93307,.0043,30.39368,1.4651,27.74108,4.1177L4.12147,27.7372c-5.4953,5.4953-5.4953,14.4369,0,19.9322,2.6526,2.6526,6.192,4.1135,9.9661,4.1135s7.3135-1.4608,9.9661-4.1134l23.6196-23.6195c5.4953-5.4953,5.4953-14.4369,0-19.9322C45.02067,1.4651,41.48128,.0043,37.70717,.0043h0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 18.68197,
    y1: 20.1363,
    x2: 31.54138,
    y2: 32.9957
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPill);
export default __webpack_public_path__ + "static/media/pill.8c2b1e84d9bf6026b29fdabbf874b085.svg";
export { ForwardRef as ReactComponent };